import React, { useState } from "react";
import { Clock, ArrowRight, Link2, Check } from "lucide-react";
import { buildUniversalExtractUrl, copyTextToClipboard } from "../constants";
import GenerateCard from "./GenerateCard";
import { docTypeStyle } from "./studioConst";
import { SX, FRAME, TX } from "./studioTokens";

const RecentCard = ({ tpl, onOpen }) => {
  const s = docTypeStyle(tpl.document_type);
  const [copied, setCopied] = useState(false);
  const copyEndpoint = (e) => {
    e.stopPropagation();
    if (!tpl.slug) return;
    copyTextToClipboard(buildUniversalExtractUrl(tpl.slug)).catch(() => {});
    setCopied(true); setTimeout(() => setCopied(false), 1600);
  };
  return (
    <div className={`group p-4 cursor-pointer ${SX.card} ${SX.cardHover}`} onClick={() => onOpen(tpl)}>
      <div className={`${TX.cardTitle} truncate group-hover:text-[#893F82] transition-colors`}>{tpl.name}</div>
      <span className={`${SX.badge} mt-1.5 ${s.badge}`}>{s.label}</span>
      <div className="flex items-center justify-between mt-3.5 gap-2">
        <span className="text-[12px] text-[#52525B] truncate">
          {tpl.fields?.length || 0} fields · {tpl.updated_at ? new Date(tpl.updated_at).toLocaleDateString() : "—"}
        </span>
        {tpl.slug && (
          <button onClick={copyEndpoint} title="Copy the extraction endpoint for this template"
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-[11px] font-semibold flex-shrink-0 transition-colors ${copied ? "border-[#E9D2E6] bg-[#FBF5FA] text-[#893F82]" : "border-[#ECE9EE] bg-white text-[#52525B] hover:bg-[#F5F5F5]"}`}>
            {copied ? <><Check size={11} /> Copied</> : <><Link2 size={11} /> Copy Endpoint</>}
          </button>
        )}
      </div>
    </div>
  );
};

/* 02 · Template Builder — AI-first landing, centred 960px column on the canvas
   with a 28px gap between the generate block and the recent grid. */
const BuilderLanding = ({ onGenerate, isGenerating, generateError, recent, onOpenTemplate, onOpenLibrary, onManual }) => (
  <div className={`flex-1 overflow-auto ${FRAME.canvas} ${FRAME.canvasPad}`}>
    <div className={`flex flex-col ${FRAME.blockGap} ${FRAME.builder}`}>
      <GenerateCard onGenerate={onGenerate} isGenerating={isGenerating} error={generateError} onManual={onManual} />

      {recent && recent.length > 0 && (
        <div className={`${SX.card} p-6`}>
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className={`flex items-center gap-2 ${TX.sectionHeading}`}>
                <Clock size={16} /> Recent Templates
              </div>
              <div className={`${TX.helper} mt-0.5`}>Continue working on your recent templates</div>
            </div>
            <button className="flex items-center gap-1.5 text-[13px] font-semibold text-[#A04A97] hover:text-[#893F82]" onClick={onOpenLibrary}>
              View all templates <ArrowRight size={14} />
            </button>
          </div>
          <div className="grid grid-cols-3 gap-3.5">
            {recent.slice(0, 3).map((t) => <RecentCard key={t.id} tpl={t} onOpen={onOpenTemplate} />)}
          </div>
        </div>
      )}
    </div>
  </div>
);

export default BuilderLanding;
